// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackUserCreatedParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/user/trackUserCreated";
import { PartialSpecific } from "@toolkit/Framework/Types/Common";

const useTrackUserCreated = (
    parameters: PartialSpecific<TrackUserCreatedParameters, "has_approver" | "role"> = {},
    options?: Toolkit.GoogleAnalytics.Options,
) => {
    return ga.util.getEventTrackerHook(ga.track.userCreated, parameters, options);
};

export default useTrackUserCreated;
